import { FC } from 'react';
import Box from 'yoda-ui/components/Box';
import { TagCommon } from 'yoda-ui/components/Tags/Tags.types';
import { YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

type TagProps = TagCommon & {
  fitContent?: boolean;
  border?: boolean;
  fontWeight?: YodaFontWeight;
  paddingY?: YodaSpacing;
  paddingX?: YodaSpacing;
  width?: string;
  height?: string;
  minHeight?: string;
  borderRadius?: string;
  fontSize?: string;
  lineHeight?: string;
  borderColor?: string;
  children?: React.ReactNode;
};

const useTagStyles = (props: TagProps) => ({
  display: props.fitContent ? 'inline' : 'block',
  backgroundColor: props.bgcolor || YodaColors.gray5,
  border: props.border ? `1px solid ${props.borderColor || props.color}` : '',
  minHeight: props.minHeight || null,
});

const Tag: FC<TagProps> = ({ children, color, fontWeight, paddingX, paddingY, borderRadius, fontSize, lineHeight, ...rest }) => {
  const style = useTagStyles(rest);
  return (
    <Box
      borderRadius={ borderRadius || YodaBorderRadius.small }
      sx={ style }
      color={ color || YodaColors.white }
      display="flex"
      fontSize={ fontSize || YodaFontSize.medium }
      lineHeight={ lineHeight }
      fontWeight={ fontWeight || YodaFontWeight.light }
      justifyContent="center"
      paddingX={ paddingX || YodaSpacing.xxSmall }
      paddingY={ paddingY || YodaSpacing.xxSmall }
    >
      { children }
    </Box>
  );
};

export default Tag;
